module.exports = __webpack_public_path__ + "img/invitation.bb9ea0ff.svg";